import React, { Component } from "react";
import { connect } from "react-redux";
import DeviceGroupInfo from "../containers/DeviceGroupInfo";
import EditDeviceGroup from "../containers/EditDeviceGroup";
import AddDeviceGroup from "../containers/AddDeviceGroup";
import AddDevice from "../containers/AddDevice";
import DeviceInfo from "../containers/DeviceInfo";
import EditDevice from "../containers/EditDevice";
import { map, mapKV } from "../utils/map";
import { deleteDeviceGroup } from "../redux/actions/deviceGroupActions";
import { DEVICES, DEVICE_GROUPS, createInfoUrl } from "../utils/routes";
import { amauntOfAppsInBundles } from "../utils/deviceGroupUtils"
import { Progress } from "../components/Progress";
import { AreYouSureDialog } from "../dialogs/AreYouSureDialog";
import { ErrorDialog } from "../dialogs/ErrorDialog";
import { NewCRUDDeviceGroupDialog } from "../dialogs/NewCRUDDeviceGroupDialog";
import SimpleSnackbar from "../components/SimpleSnackbar";
import DeviceCommands from "../containers/DeviceCommands";
import DevicesTable from "../components/DevicesTable";
import _ from "lodash";
import { getInstalledAppVersion } from "../redux/actions/deviceActions";
import { withStyles } from '@material-ui/styles';


const styles = (theme) => ({
  button: {
    display: 'block',
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  barContainer: {
    height: '200px'
  }
});

export class devicePage extends Component {
  state = {
    showAddDeviceGroupDialog: false,
    showAddDeviceDialog: false,
    showGroupEditDialog: false,
    showAreYouSureDialog: false,
    showErrorDialog: false,
    showDeviceEditDialog: false,
    filteredApp: ""
  };

  extractAmauntOfDevicesInGroup = groupId => {
    const { devices } = this.props;
    let numDevices = 0;
    map(devices, ({ deviceGroupRef }) => {
      if (deviceGroupRef && deviceGroupRef.id == groupId) {
        numDevices++;
      }
    });
    return numDevices;
  };

  render() {
    // console.log("RENDER (Page)");
    const {
      loading,
      deviceGroups,
      deleteDeviceGroup,
      apps
    } = this.props;


    const {
      showDeviceEditDialog,
      showGroupEditDialog,
      showAddDeviceGroupDialog,
      showAddDeviceDialog,
      showAreYouSureDialog,
      showErrorDialog,
      showDeviceCommands,
      commandsProps,
    } = this.state;

    const { history, match } = this.props;
    const { selectedDeviceKey, selectedGroupKey } = match.params;

    return (
      <div>
        {loading && <Progress />}

        {selectedGroupKey && (
          <NewCRUDDeviceGroupDialog
            deviceGroupId={selectedGroupKey}
            onClose={() => history.push(DEVICES)}
            onDelete={() => {
              if (this.extractAmauntOfDevicesInGroup(selectedGroupKey) <= 0)
                this.setState({ showAreYouSureDialog: true });
              else this.setState({ showErrorDialog: true });
            }}
          />
        )}

        {showAreYouSureDialog && (
          <AreYouSureDialog
            onClose={() => this.setState({ showAreYouSureDialog: false })}
            onDelete={() => {
              this.setState({ showAreYouSureDialog: false });
              history.push(DEVICES);
              deleteDeviceGroup(selectedGroupKey);
            }}
            title={deviceGroups[selectedGroupKey].name}
          />
        )}

        {showErrorDialog && (
          <ErrorDialog
            title={"Can't delete " + deviceGroups[selectedGroupKey].name}
            message={
              "You must first move all devices to another Device Group before you can delete this Device Group"
            }
            onClose={() => this.setState({ showErrorDialog: false })}
          />
        )}

        {showGroupEditDialog && (
          <EditDeviceGroup
            selectedKey={selectedGroupKey}
            deviceGroup={deviceGroups[selectedGroupKey]}
            onClose={() => this.setState({ showGroupEditDialog: false })}
          />
        )}

        {showAddDeviceGroupDialog && (
          <NewCRUDDeviceGroupDialog onClose={() => this.setState({ showAddDeviceGroupDialog: false })} />
        )}

        {showAddDeviceDialog && (
          <AddDevice
            onClose={() => this.setState({ showAddDeviceDialog: false })}
          />
        )}

        {selectedDeviceKey && !showDeviceEditDialog && (
          <DeviceInfo
            deviceKey={selectedDeviceKey}
            onClose={() => history.push(DEVICES)}
            onEdit={() => this.setState({ showDeviceEditDialog: true })}
            onDeviceComandsClick={commandsProps => this.setState({ showDeviceCommands: true, commandsProps })}
          />
        )}

        {showDeviceEditDialog && (
          <EditDevice
            deviceKey={selectedDeviceKey}
            onCancel={() => this.setState({ showDeviceEditDialog: false })}
          />
        )}

        {showDeviceCommands &&
          <DeviceCommands
            commandsProps={commandsProps}
            onClose={() => this.setState({ showDeviceCommands: false })}
          />}

        <DevicesTable
          onAddNewDeviceGroupClick={() => this.setState({ showAddDeviceGroupDialog: true })}
          onAddNewDeviceClick={() => this.setState({ showAddDeviceDialog: true })}
          onDeviceComandsClick={commandsProps => this.setState({ showDeviceCommands: true, commandsProps })}
        />

        <SimpleSnackbar />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  devices: state.data.devices,
  deviceGroups: state.data.deviceGroups,
  contentBundles: state.data.contentBundles,
  editDialogIsShown: state.ui.editDialogIsShown,
  loading: state.ui.loading,
  organizations: state.data.organizations,
  installedAppsOnDevice: state.data.installedAppsOnDevice,
  apps: state.data.apps
});

const mapDispatchToProps = { deleteDeviceGroup, getInstalledAppVersion };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(devicePage));
